import React, { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, RawButton, Text } from '@common-fe/common-fe';
import styled from 'styled-components';

import { DonutGroupItem } from '@/modules/investments/hooks/useInvestmentsHoldings';

import InvestmentDonutGroupsItem from './InvestmentDonutGroupsItem';

interface Props {
  isSmallMode?: boolean;
  value: DonutGroupItem[];
  isModalMode?: boolean;
}

const Wrapper = styled.div`
  max-height: 188px;
  overflow: auto;
  .group-item:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.spacings.xs};
  }
`;

const MIN_DISPLAYED = 4;
const InvestmentDonutGroups: React.FC<Props> = ({ value, isSmallMode, isModalMode }) => {
  const { t } = useTranslation();
  const [isExpanded, setExpanded] = useState(false);

  const handleToggle = useCallback(() => {
    setExpanded(!isExpanded);
  }, [isExpanded]);
  const isLargeList = useMemo(() => value.length > MIN_DISPLAYED, [value.length]);
  const formattedList = useMemo(() => {
    if (isExpanded || isSmallMode) {
      return value;
    }
    return [...value].splice(0, MIN_DISPLAYED);
  }, [isExpanded, isSmallMode, value]);

  if (isModalMode) {
    return (
      <Box direction="column" width="100%">
        {value.map(({ key, ...item }) => (
          <Box
            margin={{ bottom: 'spacing8' }}
            className="group-item"
            background="border1"
            round="container2Round"
            pad="spacing12"
            key={key}
          >
            <InvestmentDonutGroupsItem isModalMode key={key} {...item} />
          </Box>
        ))}
      </Box>
    );
  }

  return (
    <Box
      height={isSmallMode ? '132px' : ''}
      pad={{ left: isSmallMode ? '' : 'm', right: isSmallMode ? '' : 'm', bottom: isSmallMode ? '' : 'l' }}
    >
      <Wrapper>
        {formattedList.map(({ key, ...item }) => (
          <div className="group-item" key={key}>
            <InvestmentDonutGroupsItem key={key} {...item} />
          </div>
        ))}
      </Wrapper>
      {isLargeList && !isSmallMode && (
        <RawButton onClick={handleToggle} margin={{ top: 'xxs' }}>
          <Text color="textAccent" weight={400}>
            {isExpanded ? t('Show Less') : t(`Show More (${value.length - MIN_DISPLAYED})`)}
          </Text>
        </RawButton>
      )}
    </Box>
  );
};
export default InvestmentDonutGroups;
